import {IdName} from 'front-base-angular-core/angular/projects/front-base-angular-core/src/public-api';
import {Insurance} from './insurance.model';
import {HealthCard, IdentityDocument, Phone} from './register.model';
import {Address} from 'ngx-google-places-autocomplete/objects/address';

export class UserProfile {
  personalData?: UserProfilePersonalData;
  address?: UserProfileAddress;
  insurancePreferences?: UserProfileHealthInsurance;
  contactData?: UserProfileContactData;
  patientId?: number;

  constructor() {
    this.personalData = new UserProfilePersonalData();
    this.address = new UserProfileAddress();
    this.insurancePreferences = new UserProfileHealthInsurance();
    this.contactData = new UserProfileContactData();
  }
}

export class UserProfilePersonalData {
  firstName?: string;
  surname1?: string;
  surname2?: string;
  gender?: IdName;
  birthDate?: number;
  identityDocument?: IdentityDocument;
  nhc?: string;
  healthCardDocument?: HealthCard;

  constructor() {
    this.identityDocument = new IdentityDocument();
    this.healthCardDocument = new HealthCard();
  }
}

export class UserProfileAddress {
  streetType?: string;
  street?: string;
  streetNumber?: string;
  stair?: string;
  block?: string;
  floor?: string;
  door?: string;
  postalCode?: string;
  country?: any //PhoneCountryType || id;
  city?: string;
  district?: string;
  state?: string;
  addressModel?: Address;
  formattedAddress?: string;
  latitude?: number;
  longitude?: number;
}

export class UserProfileHealthInsurance {
  privateInsurance?: boolean;
  insurance?: Insurance;
}

export class UserProfileContactData {
  phone?: Phone;
  email?: string;

  constructor() {
    this.phone = new Phone();
  }
}

export class UserLink {
  refreshToken?: string;
}

export class UserProfileLink extends UserLink {
  userProfile?: UserProfile;
}

export class UserProfileLinkVerification extends UserProfileLink {
  verificationCode?: string;
}
